import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
export const rithumRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Rithum" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hideHeader={() => true} /> };
    },
    children: [
      {
        path: "callback",
        async lazy() {
          const { RithumCallback } = await import("./callback");
          return { Component: RithumCallback };
        },
      },
    ],
  },
];
